/**
 * next-intl routing configuration.
 *
 * `localePrefix: 'as-needed'` keeps English URLs un-prefixed
 * (`/blogs`, `/tutorials/foo`) and prefixes every non-EN locale
 * (`/es/blog`, `/ja/tutorials/foo`). Routes that should NOT
 * localize (admin, api, studio, etc.) live at the
 * top level of `app/` and the middleware in src/proxy.ts excludes
 * them from rewrites.
 *
 * `localeDetection: false` disables next-intl's automatic
 * Accept-Language redirect. We do our own fallback in
 * src/i18n/request.ts (URL → profile → header → en); auto-
 * redirecting EU visitors away from /blog while translations
 * are still machine-seeded would be confusing.
 */
import { defineRouting } from 'next-intl/routing'
import { defaultLocale, locales } from '@/lib/i18n/config'

export const routing = defineRouting({
  locales,
  defaultLocale,
  localePrefix: 'as-needed',
  localeDetection: false,
})
